// extracted by mini-css-extract-plugin
export default {"root":"AddCar_root__gTzw6","field":"AddCar_field__R3P-J","title":"AddCar_title__DAGCP","subtitle":"AddCar_subtitle__SE7Aq","form":"AddCar_form__DfmqC","logo":"AddCar_logo__mAB9X"};